













































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

import { validationSchema } from '@/common/ClaimsForm';

// Simple Form
import SimpleForm from 'vue-simpleform';

// Components
import Welcome from '@/components/Global/Welcome.vue';
import SectionsToComplete from '@/components/Claims/ClaimForm/SectionsToComplete.vue';
import InsuredsPolicyInformation from '@/components/Claims/ClaimForm/InsuredsPolicyInformation.vue';
import InvolvedInsuredsHealthCareProviders from '@/components/Claims/ClaimForm/InvolvedInsuredsHealthCareProviders.vue';
import PrimaryContactForThisEventOrClaim from '@/components/Claims/ClaimForm/PrimaryContactForThisEventOrClaim.vue';
import InformationAboutThePatientOrClaimantInvolved from '@/components/Claims/ClaimForm/InformationAboutThePatientOrClaimantInvolved.vue';
import InformationAboutClaimIncident from '@/components/Claims/ClaimForm/InformationAboutClaimIncident.vue';
import ClaimantPlantiffAttorneyInformation from '@/components/Claims/ClaimForm/ClaimantPlantiffAttorneyInformation.vue';
import NoticesSignaturesSubmissionOfReport from '@/components/Claims/ClaimForm/NoticesSignaturesSubmissionOfReport.vue';
import FileUploads from '@/components/Claims/ClaimForm/FileUploads.vue';

import ModalClaimSubmission from '@/components/Modal/ClaimSubmission.vue';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';

import Auth from '@/services/Auth';
import Claims from '@/services/Claims';

import jQuery from 'jquery';
import * as Sentry from '@sentry/browser';
import Brand from '@/services/Brand';
import VueRecaptcha from 'vue-recaptcha';
import router from '@/router';

@Component({
	name: 'ClaimsForm',
	components: {
		Welcome,
		SimpleForm,
		SectionsToComplete,
		InsuredsPolicyInformation,
		InvolvedInsuredsHealthCareProviders,
		PrimaryContactForThisEventOrClaim,
		InformationAboutThePatientOrClaimantInvolved,
		InformationAboutClaimIncident,
		ClaimantPlantiffAttorneyInformation,
		NoticesSignaturesSubmissionOfReport,
		FileUploads,
		ModalClaimSubmission,
		Loading,
		Alert,
		VueRecaptcha,
	},
})
export default class ClaimsForm extends Vue {
	@State('fields', { namespace: 'ClaimsForm' })
	private fields: any;

	@Mutation('updateInsuredsPolicyInformation', { namespace: 'ClaimsForm' })
	private updateClaimData: any;

	private readonly Auth = Auth;
	private brand: string;
	private readonly Brand = Brand;
	private cloneField: any = {};
	private errors: any = {};
	private isRecaptchaVerified: boolean = false;
	private isSubmtting: boolean = false;
	private loading: boolean = false;
	private sitekey: string =
		Brand.getBrand() === 'umia'
			? '6LezYq4ZAAAAAPbTmBE3XIq9UcXR7BhROLImQhOd'
			: Brand.getBrand() === 'mmic'
			? '6LdWVa4ZAAAAALRKJ8oRlWVQhadMKKw8lKgUzIyL'
			: Brand.getBrand() === 'amic'
			? '6Ld3u9cZAAAAAO3X4OUzeOlufKBKVyWmu4AFtinR'
			: '';
	private success: boolean = false;
	private errorSubmitting: boolean = false;
	private validationError: boolean = false;

	private created(): void {
		this.cloneField = Object.assign({}, this.fields);
		if (Auth.checkPermission(('LOGGED_IN'))) {
			this.fields.isUserLoggedIn = true;
		} else {
			this.$router.push({
				name: 'new-public-claims-form',
			});
		}
	}

	private onChange(values) {
		this.updateClaimData(values);
	}

	private newClaim() {
		// @ts-ignore
		window.location.reload();
	}

	private login() {
		this.$router.push({
			name: 'login',
		});
	}

	private brandChanged() {
		this.sitekey = this.brand === 'umia'
			? '6LezYq4ZAAAAAPbTmBE3XIq9UcXR7BhROLImQhOd'
			: this.brand === 'mmic'
			? '6LdWVa4ZAAAAALRKJ8oRlWVQhadMKKw8lKgUzIyL'
			: this.brand === 'amic'
			? '6Ld3u9cZAAAAAO3X4OUzeOlufKBKVyWmu4AFtinR'
			: '';
	}
	private onRecaptchaVerified(response) {
		if (response) {
			this.isRecaptchaVerified = true;
		}
	}

	private onRecaptchaExpired() {
		this.isRecaptchaVerified = false;
	}

	private async handleSubmit({ values, errors, setSubmitting, setSubmitted }) {
		if (this.isRecaptchaVerified || Auth.checkPermission('LOGGED_IN')) {
			this.validationError = false;
			if (errors && Object.keys(errors).length > 0) {
				window.scrollTo(0, 0);
				this.validationError = true;
				return;
			}
			jQuery('.disable-fields').addClass('enable');
			jQuery('#ClaimSubmission')
				.appendTo('body')
				.modal('show');

			const files = this.removeEmptyFiles(values.supportDocuments.fileLog);

			this.isSubmtting = true;
			this.errorSubmitting = false;
			try {
				try {
					// Upload Files First
					if (files.length > 0) {
						let getPresignedUrls;
						if (Auth.checkPermission('LOGGED_IN')) {
							getPresignedUrls = await Claims.getPresignedUrls(files);
						} else {
							getPresignedUrls = await Claims.getPublicPresignedUrls(files);
						}

						const uploadFiles = await this.uploadFiles(getPresignedUrls.data, values);
						values.supportDocuments.uploads = uploadFiles
							// @ts-ignore
							.filter(uc => uc.failed === false)
							.map(uc => {
								const data = {
									// @ts-ignore
									fname: uc.fname,
									// @ts-ignore
									fileLocation: uc.fileLocation,
								};
								return data;
							});
					}
				} catch (e) {
					console.log(e);
					Sentry.captureException(e);
				}

				try {
					let saveClaim;
					if (Auth.checkPermission('LOGGED_IN')) {
						saveClaim = await Claims.saveClaimData(values);
					} else {
						values.brand = this.brand;
						saveClaim = await Claims.savePublicClaimData(values);
					}
					console.log('saved claim', saveClaim);
					const notify = await Claims.notifyClaimFilesUploaded(saveClaim.data);
					console.log('notified about claims upload');
					jQuery('#ClaimSubmission').modal('hide');
					this.success = true;
					window.scrollTo(0, 0);
					window.localStorage.removeItem('claim-form');
				} catch (e) {
					Sentry.captureException(e);
					jQuery('#ClaimSubmission').modal('hide');
					this.errorSubmitting = true;
				}
			} finally {
				this.isSubmtting = false;
			}
		}
	}

	private validation(values) {
		const newErrors = {};
		const yupvalidation = validationSchema;
		console.log(yupvalidation);
		try {
			yupvalidation.validateSync(values, {
				recursive: true,
				abortEarly: false,
				context: { values },
			});
			this.errors = {};
		} catch (e) {
			console.log(e);
			e.inner.map(field => {
				newErrors[field.path] = field.message;
			});

			const errors = Object.keys(this.errors).map(key => {
				const message = this.errors[key];

				if (!newErrors[key]) {
					delete this.errors[key];
				}
			});

			this.errors = Object.assign({}, this.errors, newErrors);
		}

		return this.errors;
	}

	private removeEmptyFiles(files) {
		return files.filter(file => file.file_name !== '');
	}

	private async uploadFiles(signedUrls, values) {
		// tslint:disable-next-line: prefer-const
		let uploadResponse = [];
		return await Promise.all(
			signedUrls.map(async (url, index) => {
				const currentSignedUrl = url;

				const currentFile = await this.searchFilesArray(currentSignedUrl.fname, values);

				if (currentFile === false) {
					return false;
				}

				const fileLogIndex = values.supportDocuments.fileLog.findIndex(
					file => file.file_name === currentSignedUrl.fname,
				);

				const config = {
					onUploadProgress: progressEvent => {
						Vue.nextTick(() => {
							values.supportDocuments.fileLog[fileLogIndex].progress = Math.round(
								(progressEvent.loaded * 100) / progressEvent.total,
							);
						});
					},
				};

				try {
					const file = await Claims.uploadFiles(
						currentSignedUrl.upload_url,
						currentFile,
						config,
					);
					url.failed = false;
					uploadResponse.push(file);
				} catch (e) {
					console.log(JSON.stringify(e));
					// Sentry.captureException(e);
					values.supportDocuments.fileLog[fileLogIndex].failed = true;
					url.failed = true;
				}

				return url;
			}),
		);
	}

	private searchFilesArray(needle, values) {
		const getFiles = values.supportDocuments.files;
		for (let i = getFiles.length - 1; i >= 0; i--) {
			const currentFile = getFiles[i];

			if (needle === currentFile.name) {
				return currentFile;
			}

			if (i === 0) {
				return false;
			}
		}
	}
}
